module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('div', {
    staticClass: "shape"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 800 70",
      "preserveAspectRatio": "none"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M800,60c0,0-58-11-162-11c-164,0-227,21-403,21C102,70,0,60,0,60V0.2h800V60z"
    }
  })])]), _c('ul', [_c('li', {
    staticClass: "mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": "exact",
      "data-title": "Home"
    }
  }, [_vm._v("Home")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ballsaal",
      "exact": "exact",
      "data-title": "Ballsaal"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.linkHover($event)
      }
    }
  }, [_vm._v("Ballsaal")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/co-working",
      "exact": "exact",
      "data-title": "Co-Working"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.linkHover($event)
      }
    }
  }, [_vm._v("Co-Working")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/kaffeehaus",
      "exact": "exact",
      "data-title": "Kaffeehaus"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.linkHover($event)
      }
    }
  }, [_vm._v("Kaffeehaus")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/hof",
      "exact": "exact",
      "data-title": "Der Hof"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.linkHover($event)
      }
    }
  }, [_vm._v("Der Hof")])], 1), _c('li', {
    staticClass: "mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/kontakt",
      "exact": "exact",
      "data-title": "Kontakt"
    }
  }, [_vm._v("Kontakt")])], 1)]), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3099dbc7"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = 422
// module chunks = 1